import * as Yup from "yup";

export const validationSchema = Yup.object({
    settingKey: Yup
        .string()
        .required("Required"),
})

export const initialValues = {
    settingKey: "",
}